export class UnsupportedQueryKeyFormat extends Error {
    constructor(message: string) {
        super(message)
        this.name = 'UnspportedQueryKeyFormat'
    }
}

export class SnapshotNotFoundError extends Error {
    constructor(key: string) {
        super(`Snapshot not found for key: ${key}`)
        this.name = 'SnapshotNotFoundError'
    }
}
